module.exports = __webpack_public_path__ + "static/media/vk_grey_big.4faa232a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/vk_grey_big.png
// module id = ./src/assets/media/vk_grey_big.png
// module chunks = 16